import { render, staticRenderFns } from "./companyPc.vue?vue&type=template&id=1ed4547a&scoped=true"
import script from "./companyPc.vue?vue&type=script&lang=js"
export * from "./companyPc.vue?vue&type=script&lang=js"
import style0 from "./companyPc.vue?vue&type=style&index=0&id=1ed4547a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed4547a",
  null
  
)

export default component.exports